import { useState, useEffect } from 'react';
import { Tabs, Space } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import axios from 'axios';
import { color } from '@mui/system';
import Tab1 from './Tab1';
import Tab2 from './Tab2';
import Tab3 from './Tab3';
import { Print, Save, ViewAgenda, ViewColumn } from '@mui/icons-material';
import Utilisateur from '../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import Data from '../../../Data/Data.json'
import Utilis from '../../../Models/Utilis';
import DistantProfils from '../../../Models/DistantProfils';
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../Functions/Security/Crypter';
import Hash from '../../../Functions/Security/Hash';
import { Typography } from '@mui/material';
import formatDate from '../../../Functions/Traitement/fomatDate';
import ReformatDate from '../../../Functions/Traitement/ReformatDate';
//import "../../Assets/Styles/StyleForm.css";



//CreateNewCLIENT
//const Swal = require('sweetalert2');
//let LinkSourceApi= require('../../Data/Data.json');

const User = () => {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

  // USER TOKEN
  const authHeader = useAuthHeader()

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartSearchG, SeStartSearchG] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false)
  const [ajoutActve, setAjoutActif] = useState(false)
  const [modifActve, setModifActve] = useState(true)
  const [enregActve, setEnregActve] = useState(true)
  const [supActive, setSupActive] = useState(true)
  const [impActive, setImpActive] = useState(true)
  const [actuActive, setActActive] = useState(true)
  const [annulActive, setAnnulActive] = useState(true)
  const [consulActive, setConsulActive] = useState(false)
  const [sbmit, setSbmit] = useState("")
  const [connecte, setConnecte] = useState(false)
  const [resetPasAct, setResetPasAct] = useState(false)


  useEffect(() => {
    forceUpdate({});
  }, []);

  function initialiazeButton() {
    setResetPasAct(false)
    setConnecte(false)
    setAjoutActif(false)
    setModifActve(true)
    setEnregActve(true)
    setSupActive(true)
    setImpActive(true)
    setActActive(true)
    setAnnulActive(true)
    setConsulActive(false)
  }

  // Champs de plafonds — initialisés à 0 à la création (même si l'onglet n'est pas ouvert)
  const PLAFOND_FIELDS = [
    "debint", "debClt", "validInt", "depassInt", "alertDebClt", "depassCpt",
    "credInt", "credClt", "validClt", "depassClt", "alertCreClt",
    "debInt2", "debClt2", "validInt2", "depassInt2", "alertDebClt2", "depassCpt2",
    "credInt2", "credClt2", "validClt2", "depassClt2", "alertCreClt2",
  ];

  const SetStart = () => {

    localStorage.setItem(Data.LocalVariable.reset, '0')
    setSbmit("add")
    setAjoutActif(true)
    setEnregActve(false)
    setAnnulActive(false)
    setConsulActive(true)
    form.resetFields()

    form.setFieldValue("MOTPAS", Hash("12345678"))
    form.setFieldValue("CONF_MOTPAS", Hash("12345678"))
    form.setFieldValue("CODAGE", user?.codage || "")
    form.setFieldValue("lib_CODAGE", user?.agence || "")
    // plafonds à 0 par défaut (Tab2 peut ne jamais être ouvert)
    const zeroPlafonds: any = {};
    PLAFOND_FIELDS.forEach(f => { zeroPlafonds[f] = 0 });
    form.setFieldsValue(zeroPlafonds);
  }

  const SetEndStart = () => {
    SetStartForm(true);
    SeStartSearchG(false)
  }
  function handleAnulle() {
    let coduti = form.getFieldValue("CODUTI")
    form.resetFields()
    localStorage.clear()
    form.setFieldValue("CODUTI", coduti)
    initialiazeButton()
    localStorage.setItem(Data.LocalVariable.reset, "1")
    form.setFieldValue("CODAGE", user?.codage || "")
    form.setFieldValue("lib_CODAGE", user?.agence || "")
  }
  function cunsultButton() {
    setAnnulActive(false)
    setModifActve(false)

  }

  function modifButton() {
    setSbmit("update")
    setModifActve(true)
    setAjoutActif(true)
    setEnregActve(false)
    setConsulActive(true)
  }


  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Infos Générale
        </span>
      ),
      children: <Tab1 form={form} disabled={ajoutActve} isUpdate={sbmit === 'update'} />,
    },
    {
      key: '2',
      label: (
        <span id='Tab'>
          <ContactsOutlined />
          Plafond
        </span>
      ),

      children: <Tab2 />,
    },
    {
      key: '3',
      label: (
        <span id='Tab'>
          <UsergroupAddOutlined />
          Agence/Profile
        </span>
      ),
      children: <Tab3 form={form} />,
    },
  ];

  const onFinish = (values: any) => {

    values.NUMCPT = form.getFieldValue("NUMCPT")
    values.INDUTI = values.INDUTI? values.INDUTI : ""
    values.NUMCPT = values.NUMCPT? values.NUMCPT : ""
    values.ANOMUTI = values.lib_CODUTI+""

    var profilsDistant : any[] = [];
    var codeGroup: String = "";

    try {
      //console.log(localStorage.getItem(Data.LocalVariable.userDistanceHabillitation))
      profilsDistant = JSON.parse(Crypter.decrypt(localStorage.getItem(Data.LocalVariable.userDistanceHabillitation) + ""))
      codeGroup = profilsDistant.find((pd: DistantProfils) => pd.CODAGE == values.CODAGE).CODGROUP
    } catch (error) {
      codeGroup = ""
      //alert(error)
    }

    const debint = form.getFieldValue("debint");
    if (debint !== undefined && debint !== null && debint !== "") {
      if (profilsDistant.length != 0) {
  
        if (values.MOTPAS == values.CONF_MOTPAS) {
  
          //console.log(Crypter.decrypt(localStorage.getItem(Data.LocalVariable.userDistanceHabillitation)+""))
          SweetAlert.fire({
            title: (sbmit == 'add' ? "Enregistrement" : "Modification") + " de l'utilisateur",
            text: "Voulez-vous " + (sbmit == 'add' ? "enregistrer" : "modifier") + " l'utilisateur " + values.CODUTI + " ?",
            showCancelButton: true,
            color: "#116599",
            confirmButtonText: "Yes",
            confirmButtonColor: "#116599",
            cancelButtonColor: "darkred",
            cancelButtonText: "No",
            showLoaderOnConfirm: true,
            icon: 'question'
          }).then((res) => {
            if (res.isConfirmed) {
              setLoading(true);
              setIsSubmit(true)
  
              values = { "UTILIS": user.coduti, ...values, "profilsDistant": profilsDistant, "CODGROUP": codeGroup }
              var utilis: Utilis = values
              utilis.MOTPAS = Hash(utilis.MOTPAS)
              utilis.datNaissUti = formatDate(utilis.datNaissUti)
              utilis.datnais = formatDate(utilis.datnais)
              //alert(utilis.NUMCPT)
  
              console.log('Received values of form: ', Crypter.encrypt(JSON.stringify(utilis)));
  
              let data = Crypter.encrypt(JSON.stringify(utilis));
  
              let config = {
                method: (sbmit == 'add' ? 'post' : 'put'),
                maxBodyLength: Infinity,
                url: (sbmit == 'add' ? Data.ApiUrl.CreateUser : Data.ApiUrl.UpdateUser),
                headers: {
                  // 'CypherUser': data,
                  'Authorization': authHeader(),
                  'Content-Type': 'application/json'
                },
                data: data
              };
  
              axios.request(config)
                .then((response) => {
                  setLoading(false);
                  if (response.data) {
                    const res = JSON.parse(Crypter.decrypt(response.data)).Value;
  
                    if (res.StatutCode == 200) {
                      let code = values.CODUTI
                      form.resetFields()
                      localStorage.clear()
                      setIsSubmit(false)
                      SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                      initialiazeButton()
                      localStorage.setItem(Data.LocalVariable.reset, "1")
                    }
                    else {
                      SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                    }
                  }
                })
                .catch((error) => {
                  setLoading(false);
                  console.log(error)
                  SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                })
            }
          })
        } else {
          SweetAlert.fire({ title: "Warning", text: "Vérifiez la confirmation du mot de passe", icon: "warning" })
        }
      }
      else {
        SweetAlert.fire({ title: "Warning", text: "Veillez paramétrer les habillitations de l'utilisateur", icon: "warning" })
      }
    }else{
      SweetAlert.fire({ title: "Warning", text: "Veillez saisir les plafonds de l'utilisateur", icon: "warning" })
    }

  };

  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];

    errorInfo.errorFields.map((error: any) => {

      errors.push(error.name + "");
    })

    SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })

  };

  function consult() {

    setConnecte(false)
    localStorage.setItem(Data.LocalVariable.reset, "1")
    let cod = form.getFieldValue("CODUTI")
    let lib_cod = form.getFieldValue("lib_CODUTI")
    let data = Crypter.encrypt(cod);
    if (data.length != 0) {
      initialiazeButton()
      setLoading(true)
      form.resetFields()

      form.setFieldValue("CODUTI", cod)
      form.setFieldValue("lib_CODUTI", lib_cod)

      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.AfficheUser,
        headers: {
          'CypherUserCode': data,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };
      axios.request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;

            if (res.StatutCode == 200) {

              console.log(res)
              form.setFieldsValue(res.Result.Table[0])
              form.setFieldValue("CONF_MOTPAS", res.Result.Table[0].MOTPAS)
              form.setFieldValue("datnais", ReformatDate(res.Result.Table[0].datnais))
              // Indice vide -> utilisateur temporaire
              const induti = res.Result.Table[0].INDUTI;
              form.setFieldValue("tmpUser", !(induti && String(induti).trim() !== ""))

              localStorage.clear()
              initialiazeButton()

              localStorage.setItem(Data.LocalVariable.userDistanceHabillitation, Crypter.encrypt(JSON.stringify(res.Result.Table1)))
              cunsultButton()

              localStorage.setItem("numcpt", Crypter.encrypt(res.Result.Table[0].NUMCPT))
              setConnecte(res.Result.Table[0].CONNECT)
              setResetPasAct(res.Result.Table[0].MOTPAS != Hash('12345678'))

            }
            else {
              SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
            }
          }
          setLoading(false)
        })
        .catch((error) => {
          setLoading(false);
          console.log(error)
          SweetAlert.fire({ title: "Error", text: error, icon: "error" })
        });
    }
  }
  function modif() {
    modifButton()
  }

  function logOut() {

    if (form.getFieldValue("CODUTI").length != 0) {
      SweetAlert.fire({
        title: "Déconnexion",
        text: "Voulez-vous vraiment vous déconnecter l'utilisateur " + form.getFieldValue("CODUTI") + "(" + form.getFieldValue("lib_CODUTI") + ")" + "?",
        showCancelButton: true,
        color: "#116599",
        confirmButtonText: "Yes",
        confirmButtonColor: "#116599",
        cancelButtonColor: "darkred",
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
        icon: 'question'
      }).then((res) => {
        if (res.isConfirmed) {

          //SweetAlert.showLoading()
          setLoading(true)

          let data = Crypter.encrypt(form.getFieldValue("CODUTI"));
          let config = {
            method: 'put',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.LogOut,
            headers: {
              'Authorization': authHeader(),
              'CipherUserCode': data,
            },
            //data: data
          };

          axios.request(config)
            .then((response) => {
              let res = JSON.parse(Crypter.decrypt(response.data)).Value
              if (res.statutCode = 200) {
                SweetAlert.fire({
                  title: "Success",
                  text: res.Message + "",
                  icon: 'success',
                  cancelButtonColor: "darkred",
                  cancelButtonText: "Cloase",
                })
                form.setFieldValue("CONNECT", false)
                setConnecte(false)
              }
              setLoading(false)
            })
            .catch((error) => {
              setLoading(false)
              SweetAlert.fire({
                title: "Déconnexion",
                text: error.message + "",
                icon: 'error',
                cancelButtonColor: "darkred",
                cancelButtonText: "Cloase",
              })
            });
        }
      }).catch(() => {
        SweetAlert.fire({
          title: "Déconnexion",
          text: "Veillez saisir le Code de l'utilisateur",
          icon: 'error',
          cancelButtonColor: "darkred",
          cancelButtonText: "Cloase",
        })
      })
    }
  }

  function resetPass() {

    if (form.getFieldValue("CODUTI").length != 0) {
      SweetAlert.fire({
        title: "Reset Password",
        text: "Voulez-vous vraiment réinitialiser le motde passe de l'utilisateur " + form.getFieldValue("CODUTI") + "(" + form.getFieldValue("lib_CODUTI") + ")" + "?\nL'utilisateur le modifira à sa prochaine connexion.",
        showCancelButton: true,
        color: "#116599",
        confirmButtonText: "Yes",
        confirmButtonColor: "#116599",
        cancelButtonColor: "darkred",
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
        icon: 'question'
      }).then((res) => {
        if (res.isConfirmed) {

          //SweetAlert.showLoading()
          setLoading(true)

          var data = { "coduti": form.getFieldValue("CODUTI"), "motpas": Hash('12345678'), "encienmotpas": "-1" };
          let config = {
            method: 'put',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.setPassword,
            headers: {
              'Authorization': authHeader(),
              'CipherUser': Crypter.encrypt(JSON.stringify(data)),
            },
            // data: data
          };

          axios.request(config)
            .then((response) => {
              let res = JSON.parse(Crypter.decrypt(response.data)).Value
              if (res.StatutCode == 200) {
                SweetAlert.fire({
                  title: "Success",
                  text: res.Message + "",
                  icon: 'success',
                  cancelButtonColor: "darkred",
                  cancelButtonText: "Cloase",
                })
                form.setFieldValue("CONNECT", false)
                setConnecte(false)
              }
              else {
                SweetAlert.fire({
                  title: "Reset refusé",
                  text: res.Message + "",
                  icon: 'warning',
                  cancelButtonColor: "darkred",
                  cancelButtonText: "Cloase",
                })
              }
              setLoading(false)
            })
            .catch((error) => {
              setLoading(false)
              SweetAlert.fire({
                title: "Déconnexion",
                text: error.message + "",
                icon: 'error',
                cancelButtonColor: "darkred",
                cancelButtonText: "Cloase",
              })
            });
        }
      }).catch(() => {
        SweetAlert.fire({
          title: "Déconnexion",
          text: "Veillez saisir le Code de l'utilisateur",
          icon: 'error',
          cancelButtonColor: "darkred",
          cancelButtonText: "Cloase",
        })
      })
    }
  }


  return (
    <div className='tab'>
      <Typography align='center' className='formTitle'><b>GESTION D'UTILISATEUR</b></Typography>
      <Spin spinning={loading} size='large' style={{ color: '#116599' }} >
        <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
          <div className='bG'>
            <legend><Typography color={"#116599"}>Actions</Typography></legend>
            <Form.Item shouldUpdate className='bouttong'>
              <Space direction="vertical" style={{ width: '100%' }}>

                <Button size='large' className='bt_add' disabled={consulActive} onClick={consult} type="ghost" htmlType="button" block  >
                  Consulter
                </Button>

                <Button size='large' className='bt_add' disabled={ajoutActve} onClick={SetStart} type="ghost" htmlType="button" block  >
                  Ajouter
                </Button>
                <Button size='large' className='bt_add' disabled={modifActve} onClick={modif} type="ghost" htmlType="button" block  >
                  Modifier
                </Button>
                <Button size='large' className='bt_add' disabled={enregActve} type="ghost" htmlType="submit" block>
                  Enregistrer
                </Button>
                <Button size='large' onClick={logOut} className='bt_add' disabled={!connecte} type="ghost" htmlType="button" block>
                  Déconnecter
                </Button>
                <Button size='large' onClick={resetPass} className='bt_add' disabled={!resetPasAct} type="ghost" htmlType="button" block>
                  Reset pass
                </Button>
                <Button size='large' className='bt_add' onClick={SetEndStart} disabled={supActive} type="ghost" htmlType="button" block>
                  Supprimer
                </Button>
                <Button size='large' className='bt_add' disabled={impActive} type="ghost" htmlType="button" block  >
                  Imprimer
                </Button>
                <Button size='large' className='bt_add' disabled={actuActive} type="ghost" htmlType="button" block  >
                  Actualiser
                </Button>
                <Button size='large' disabled={annulActive} onClick={handleAnulle} className='bt_add' type="ghost" htmlType="reset" block>
                  Annuler
                </Button>
              </Space>
            </Form.Item>
          </div>
          <div className='clientP'>
            <div >
              <Tabs size='small' type="card" defaultActiveKey="1" items={items} />
            </div>
            <div>
            </div>
          </div>
        </Form>
      </Spin>
    </div>
  );
}
export default User;